module.exports = __webpack_public_path__ + "img/PL08923.6e1ccb8c.png";